export enum TransportRulesType {
    Internal="Nội Thành",
    External="Liên Thành Phố"
}